window.InjectCustomSdk = () => {
  return {
    analytics: {
      ga: {
        key: window.gaKey || '',
      },
    },
  };
};
